/* eslint-disable typescript-sort-keys/string-enum */
export enum GADimension {
  AffiliateCode = 'dimension1',
  License = 'dimension3',
  LangId = 'dimension5',
  ResolverTag = 'dimension10',
  GClientID = 'dimension11',
  WebClientID = 'dimension12',
  ACID = 'dimension13',
  WebIDHit = 'dimension14',
  TimeStamp = 'dimension15',
  SizmekID = 'dimension16',
  MaxymiserID = 'dimension17',
  SignalID = 'dimension18',
  WebIDSession = 'dimension20',
  PromoIA = 'dimension21',
  MSClickID = 'dimension22',
  MachineID = 'dimension25',
  ClientID = 'dimension26',
  SizmekClickID = 'dimension27',
  BrandCode = 'dimension30',
  ApplicationType = 'dimension32',
  DataSource = 'dimension33',
  ApplicationVersion = 'dimension36',
  StarsCardPhysicalCardHolder = 'dimension46',
  UIElementId = 'dimension47',
  UIElementTypeId = 'dimension48',
  UIElementName = 'dimension49',
  UIElementTitle = 'dimension50',
  UIElementLocation = 'dimension51',
  UIElementPosition = 'dimension52',
  UIElementExtendedAttributes = 'dimension53',
  VisitId = 'dimension55',
  IsRMplayer = 'dimension62',
  IsPMplayer = 'dimension63',
  BrandName = 'dimension64',
  SiteName = 'dimension65',
  HostApplicationType = 'dimension66',
  HostApplicationVersion = 'dimension67',
  FacebookClickId = 'dimension73',
  FacebookBrowserId = 'dimension74',
  MoneyType = 'dimension75',
  PageOriginPath = 'dimension76',
  GameName = 'dimension80',
  GameCode = 'dimension81',
  GameTags = 'dimension82',
  GamePlayMode = 'dimension83',
  GameJackpot = 'dimension84',
  GamesInView = 'dimension85',
  GamesTotal = 'dimension86',
  GameVariantID = 'dimension87',
  TabName = 'dimension90',
  WidgetName = 'dimension91',
  LaunchSource = 'dimension92',
  IsFavourite = 'dimension96',
  ActiveTab = 'dimension97',
  ModalContent = 'dimension98',
  WidgetContents = 'dimension99',
  Profit = 'dimension100',
  CampaignID = 'dimension101',
  InputValue = 'dimension102',
  RadioButtonActive = 'dimension103',
  HSPOrFeatureFlags = 'dimension104',
  PlayerCurrency = 'dimension105',
  Amount = 'dimension106',
  ErrorsTracked = 'dimension107',
  GameTicketNumber = 'dimension108',
  TabPosition = 'dimension109',
  AMSPromoCode = 'dimension114',
  TicketID = 'dimension116',
  DepositStatus = 'dimension118',
  DepositRedirectStatus = 'dimension119',
  DepositGateway = 'dimension120',
  TransactionType = 'dimension121',
  TransactionStatus = 'dimension122',
  Conversion = 'dimension123',
  TransactionDate = 'dimension124',
  TransactionId = 'dimension125',
  PaysystemName = 'dimension126',
  PreviouslyActioned = 'dimension127'
}
